import { useEffect } from 'react'
import { useHistory } from 'react-router-dom'
import styled from 'styled-components'

import server from 'server/serverController2'
import { getQueryStringObject } from 'utils/utils'

import LottieLodder from 'components/containers/common/LottieLoader'
import paymentAnimation from 'images/lottiefile/payment_animation.json'

export default function ProcessApproveOrder({ match }) {
  const history = useHistory()
  const { paymentKey, orderId, amount, purchase_type, options_no, challenge_no } =
    getQueryStringObject()

  const orderNo = match?.params?.orderNo

  const lottieOptions = {
    loop: true,
    autoplay: true,
    renderer: 'svg',
    animationData: paymentAnimation,
  }

  useEffect(() => {
    if (orderNo) {
      let form = {}
      form['toss_order_id'] = orderId
      form['toss_payment_key'] = paymentKey
      form['purchase_type'] = purchase_type
      form['order_item_no'] = options_no
      form['challenge_no'] = challenge_no

      server.postRequestData(`commerce/orders/${orderNo}/invoice`, form, (res) => {
        if (res.success !== 1) {
          return
        }
        history.replace(`/motishop/order/${orderNo}/invoice`)
      })
    }
  }, [challenge_no, history, options_no, orderId, orderNo, paymentKey, purchase_type])
  return (
    <ApproveOrderWrapper>
      <LoadingBlock>
        <LottieLodder
          lottieOptions={lottieOptions}
          style={{
            width: 'calc(100vw * (76 / 375))',
            height: 'calc(100vw * (76 / 375))',
          }}
        />
        <ProgressComment>{'결제 중이에요\n잠시만 기다려 주세요'}</ProgressComment>
      </LoadingBlock>
    </ApproveOrderWrapper>
  )
}

const ApproveOrderWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100vh;
`

const LoadingBlock = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`

const ProgressComment = styled.span`
  font-family: 'Pretendard';
  font-size: calc(100vw * (14 / 375));
  font-weight: 500;
  line-height: calc(100vw * (21 / 375));
  color: #4e4e4e;
  text-align: center;
  white-space: pre-wrap;
  padding-top: calc(100vw * (12 / 375));
`
